import {
  Component,
  OnInit,
  ViewChild,
  Input,
  resolveForwardRef,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router, NavigationEnd } from '@angular/router';
import * as moment from 'moment';
import { date } from 'ngx-custom-validators/src/app/date/validator';
import { AppNotificationService } from '../../services/app-notification/app-notification.service';
import { DataService } from '../../services/data.service';
//import { OrderService } from '../../../views/order/order.service';
import { PassService } from '../../services/passEmitData.service';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { Injectable } from '@angular/core';
import { resetFakeAsyncZone } from '@angular/core/testing';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
})
@Injectable({ providedIn: 'root' })
export class NotificationsComponent implements OnInit {
  @Input() notificPanel;

  currentUser: any = {};
  pageReminder: number = 1;
  pageNoti: number = 1;
  typeLoad;
  // Dummy notifications
  reminders: any;
  notifications: any;
  totalAllNoti: number = 0;
  totalNotSeen: number = 0;
  totalAllReminders: number = 0;
  totalNotSeenReminders: number = 0;

  constructor(
    private router: Router,
    private pass: DataService,
    //private order: OrderService,
    private notify: AppNotificationService
  ) {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
    this.reminders = [];
    this.notifications = [];
  }

  play() {
    var audio = new Audio('../../../assets/audio/notification.mp3');
    audio.play();
  }

  ngOnInit() {
    this.getTotalNotSeen();
    this.pass.currentTypeLoad.subscribe((res) => {
      this.typeLoad = res;
      if (res == '1') {
        this.notifications = [];
        this.pageNoti = 1;
        this.getNotification();
      } else if (res == '2') {
        this.reminders = [];
        this.pageReminder = 1;
        this.getReminder();
      }
    });

    this.pass.currentTotalSeen.subscribe((res) => {
      this.getTotalNotSeen();
    });

    this.router.events.subscribe((routeChange) => {
      if (routeChange instanceof NavigationEnd) {
        this.notificPanel.close();
      }
    });
  }

  getNotification() {
    // this.order
    //   .getNotificationByUser(this.currentUser.id, this.pageNoti, 20)
    //   .subscribe(({ value, total, totalNotSeen }) => {
    //     this.totalAllNoti = total;
    //     this.totalNotSeen = totalNotSeen;
    //     value.forEach((item) => {
    //       this.notifications.push({
    //         ...item,
    //         time: moment(new Date(item.CreateDate), 'YYYYMMDD').fromNow(),
    //         route: '/order',
    //       });
    //     });
    //     this.pass.changeMessage(this.totalNotSeen.toString());
    //   });
  }

  onScroll(event) {
    if (
      event.target.scrollTop <
      event.target.scrollHeight - event.target.offsetHeight - 1
    ) {
      return;
    }
    if (this.reminders.length >= this.totalAllReminders) {
      return;
    }

    this.pageReminder = this.pageReminder + 1;
    this.getReminder();
  }

  onNotiScroll(event) {
    if (
      event.target.scrollTop <
      event.target.scrollHeight - event.target.offsetHeight
    ) {
      return;
    }
    if (this.notifications.length >= this.totalAllNoti) {
      return;
    }

    this.pageNoti = this.pageNoti + 1;
    this.getNotification();
  }

  openReminder(remind, i) {
    // if (!remind.IsRead) {
    //   this.order.updateReadStatusReminder(remind.Id).subscribe((res) => {});
    // }
    // this.router.navigate(['/order'], { queryParams: { id: remind.OrderId } });
  }

  openNoti(notification, i) {
    // if (!notification.IsRead) {
    //   this.order
    //     .updateReadStatusNotification(notification.Id)
    //     .subscribe((res) => {});
    // }
    // this.router.navigate(['/order'], {
    //   queryParams: {
    //     id: notification.OrderId,
    //     duplicate: notification.MessageType.toLowerCase().includes('dup'),
    //   },
    // });
  }

  getReminder() {
    // this.order
    //   .getReminderByUser(this.currentUser.id, this.pageReminder, 20)
    //   .subscribe(({ value, total, totalNotSeen }) => {
    //     this.totalAllReminders = total;
    //     this.totalNotSeenReminders = totalNotSeen;
    //     value.forEach((item) => {
    //       this.reminders.push({
    //         ...item,
    //         message: 'Hẹn gọi lại',
    //         time: moment(
    //           new Date(
    //             new Date(item.RemindDate).setMinutes(
    //               new Date(item.RemindDate).getMinutes() - item.BeforeTimer
    //             )
    //           ),
    //           'YYYYMMDD'
    //         ).fromNow(),
    //         route: '/order',
    //       });
    //     });
    //     this.pass.changePhoneBackNumberMessage(
    //       this.totalNotSeenReminders.toString()
    //     );
    //   });
  }

  getTotalNotSeen() {
    // this.order
    //   .getTotalNotSeen(this.currentUser.id)
    //   .subscribe(({ totalNotSeenNoti, totalNotSeenReminder }) => {
    //     this.pass.changePhoneBackNumberMessage(totalNotSeenReminder.toString());
    //     this.pass.changeMessage(totalNotSeenNoti.toString());
    //   });
  }

  // clearAll(e) {
  //   e.preventDefault();
  //   this.reminders = [];
  //   localStorage.setItem('notification', '');
  //   this.pass.changeMessage(this.numberView.toString());
  // }
}
